import iconPDR from '../../assets/images/services/pdr.png'
import iconPaintAndBody from '../../assets/images/services/paintandbody.png'
import iconInterior from '../../assets/images/services/interior.svg'
import iconWheels from '../../assets/images/services/wheels.png'
import iconDetail from '../../assets/images/services/detail.svg'
import iconTint from '../../assets/images/services/tint.png'
import iconGlass from '../../assets/images/services/glass.png'
import iconPPF from '../../assets/images/services/ppf.svg'
import iconRI from '../../assets/images/services/ri.png'
import iconMechanical from '../../assets/images/services/mechanical.svg'
import iconParts from '../../assets/images/services/parts.png'
import iconMisc from '../../assets/images/services/misc.png'
import iconPkg from '../../assets/images/services/pkg.svg'
import iconHail from '../../assets/images/services/hail.png'
import iconPriceADent from '../../assets/images/services/priceadent.png'
import iconAdas from '../../assets/images/services/adas.svg'

const SERVICE_ICONS = {
  PDR: iconPDR,
  PAINTANDBODY: iconPaintAndBody,
  INTERIOR: iconInterior,
  WHEELS: iconWheels,
  DETAIL: iconDetail,
  TINT: iconTint,
  GLASS: iconGlass,
  PPF: iconPPF,
  RI: iconRI,
  MECHANICAL: iconMechanical,
  PARTS: iconParts,
  MISC: iconMisc,
  PKG: iconPkg,
  HAIL: iconHail,
  PRICEADENT: iconPriceADent,
  ADAS: iconAdas,
}

const ServicesInfo = ({ serviceLines = {}, hideAmounts = false }) => {
  const hasValidServices = serviceLines && Object.keys(serviceLines).some(key =>
    key !== 'repairedBy' && serviceLines[key]?.trim()
  )

  if (!hasValidServices) return null

  return (
    <div className='pb-3 service-desktop'>
      <span className='d-block fs-small fw-bold'>Services</span>
      <div className='services-grid'>
        {Object.keys(serviceLines).map((key) => {
          if (key === 'repairedBy' || !serviceLines[key]?.trim()) return null

          const service = serviceLines[key]
          const name = service.substring(0, service.indexOf(':'))
          const total = service.substring(service.indexOf('$'), service.indexOf('.') + 3).trim()
          const detail = service.substring(service.indexOf('(') + 1, service.lastIndexOf(')')).trim()
          const iconSrc = SERVICE_ICONS[key.toUpperCase()]

          return (
            <div key={key} className='service-card'>
              <div className='service-card__content'>
                <div className='service-card__left'>
                  <div className='service-card__icon'>
                    {iconSrc && <img src={iconSrc} alt={name} />}
                  </div>
                  <div className='service-card__info'>
                    <span className='service-card__name'>{name}</span>
                    <span className='service-card__detail'>{detail}</span>
                  </div>
                </div>
                <span className='service-card__total'>{!hideAmounts && total}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ServicesInfo
